import React, { memo } from 'react'

// Skeleton loading
import Skeleton from 'react-loading-skeleton';

function LoadingSkeleton(props) {
    return (
        <React.Fragment>
            <div className="mb-2">
                <Skeleton count={1} height={40} width={"100%"} />
            </div>
            <div className="mb-2">
                <Skeleton count={1} height={40} width={"100%"} />
            </div>
        </React.Fragment>
    )
}

export default memo(LoadingSkeleton)